import { Link, Text } from '@stitch-fix/mode-react';

export type SignInPromptProps = {
  signInUrl?: string;
};

export const SignInPrompt = ({ signInUrl = '/login' }: SignInPromptProps) => {
  return (
    <Text as="p" setting="body-small-fixed" mt={1}>
      Already have an account? <Link href={signInUrl}>Sign in</Link>
    </Text>
  );
};
